import { render } from "./CrimeLayer.vue?vue&type=template&id=42cdeb97&ts=true"
import script from "./CrimeLayer.vue?vue&type=script&lang=ts"
export * from "./CrimeLayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__